import { isValidPhoneNumber } from 'react-phone-number-input';
import { TPhoneInput } from 'types';

const validatePhone = ({ number, countryCode }: TPhoneInput) => {
  return !number || isValidPhoneNumber(number, countryCode);
};

export default validatePhone;
